export default "__VITE_ASSET__DHqEKTPK__"